export default "__VITE_ASSET__eef0d6c9__"